import Swiper from 'swiper';

export default function() {
    new Swiper('.swiper-container', {
        slidesPerView: 'auto',
        spaceBetween: 30,
        pagination: false,
        navigation: {
            nextEl: '.c-productswiper__arrow.next',
            prevEl: '.c-productswiper__arrow.prev'
        }
    });

    new Swiper('.c-productdetail__gallery__swiper', {
        slidesPerView: 1,
        spaceBetween: 30,
        pagination: false,
        navigation: {
            nextEl: '.c-productdetail__gallery__arrow.next',
            prevEl: '.c-productdetail__gallery__arrow.prev'
        },
        breakpoints: {
            576: {
                spaceBetween: 40
            },
            787: {
                slidesPerView: 1.5
            },
            992: {
                slidesPerView: 1.75
            }
        }
    });
}
